import React, { memo, useCallback, useState } from 'react'

/**
 * TABLEQUESTION COMPONENT
 * @param {{ question: { answers: string[], optionsLabel: string[] }, quiz: Quiz }} props 
 * @returns {JSX.Element}
 */
function TableQuestion({ question, quiz }) {
  return (
    <>
      <table className="display-desktop w-full text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th />
            {question.answers.map((answer, key) => <th className="border border-gray-300 p-4 text-left font-bold text-gray-800" key={key}>{answer}</th>)}
          </tr>
        </thead>
        <tbody className='bg-white'>
          {
            question.optionsLabel.map((optionLabel, key) => (
              <tr key={key}>
                <td className='cell'>{optionLabel}</td>
                {
                  question.answers.map((ans, key) => <td key={key} className='cell'>
                    <input type="radio" name={optionLabel} defaultChecked={quiz?.['question9']?.[optionLabel] === ans} className='radio radio-accent' />
                  </td>)
                }
              </tr>
            ))
          }
        </tbody>
      </table>

      <div className="space-y-4 display-mobile">
        {
          question.optionsLabel.map((optionLabel, key) => (
            <DetailsTable title={optionLabel} key={key} indicator={key}>
              <div onClick={e => e.stopPropagation()}>
                {
                  question.answers.map((answer, k) =>
                    <label key={k}
                      htmlFor={optionLabel + answer}
                      className={`flex w-full space-x-2 items-center text-sm text-gray-700 font-light mt-4 pl-4 cursor-pointer hover:text-stone-900`}>
                      <input
                        type='radio'
                        name={optionLabel}
                        id={optionLabel + answer}
                        //defaultChecked={quiz?.['question9']?.[optionLabel] === answer}
                        className="radio radio-accent peer"
                      />
                      <span className="peer-checked:text-stone-900">{answer}</span>
                    </label>
                  )
                }
              </div>
            </DetailsTable>
          ))
        }
      </div>
    </>
  )
}

function DetailsTable({ title, children, indicator }) {
  const [open, setOpen] = useState(false)

  const toggleOpen = useCallback(() => {
    setOpen(s => !s)
  }, [])

  return (
    <details className='p-4 rounded-md open:shadow-lg font-sans border border-gray-100' open={!indicator ? true : open} onClick={toggleOpen}>
      <summary className='questions text-gray-800 cursor-pointer'>{title}</summary>
      {children}
    </details>
  )
}

export default memo(TableQuestion)